import { WebStorageStateStore } from "oidc-client-ts";
const oidcConfigTemplate = {
    redirect_uri: `${window.location.origin}/implicit/callback`,
    disablePKCE: false,
    scope: "openid email offline_access",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    fetchRequestCredentials: "include",
    accessTokenExpiringNotificationTimeInSeconds: 120,
    automaticSilentRenew: false,
};
export { oidcConfigTemplate };
export * from "./renewToken";
export * from "./constants";
export * from "./callback";
//# sourceMappingURL=index.js.map